import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';
import { OUTLAW_API_ROUTES } from '@outlaw/core';
import { CommunityConfigService } from '../util/community-config.service';
import { OutlawCommunityConfig } from '../../outlaw-community.config';
import { ArgoVideoShort } from '../../interfaces';

export type ArgoUser = {
  subscription_matrix: {
    now_subscriber: boolean;
  };
};

export type PlaylistVideosResponse = {
  videos: ArgoVideoShort[];
  hasSubscription: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class PlaylistVideosService {
  constructor(
    private http: HttpClient,
    private communityConfigService: CommunityConfigService
  ) {}

  get config(): OutlawCommunityConfig {
    return this.communityConfigService.getConfig();
  }

  getPlaylistVideos(playlistId: number): Observable<PlaylistVideosResponse> {
    const argoUrl = this.config.externalApi.argo;

    // todo: refactor
    const hasSubscription = this.http.get<ArgoUser>(`${argoUrl}${OUTLAW_API_ROUTES.userRoute}`).pipe(
      map(user => user.subscription_matrix.now_subscriber),
      catchError(error => {
        console.error(error);
        return of(false);
      })
    );

    const playlistVideos = this.getPlaylistVideosGuest(playlistId).pipe(
      catchError(error => {
        console.error(error);
        return of([]);
      })
    );

    return forkJoin([hasSubscription, playlistVideos]).pipe(
      map(([hasSubscription, videos]) => ({
        videos,
        hasSubscription,
      }))
    );
  }

  getPlaylistVideosGuest(playlistId: number): Observable<ArgoVideoShort[]> {
    const argoUrl = this.config.externalApi.argo;

    return this.http.get<ArgoVideoShort[]>(`${argoUrl}/client/playlist/${playlistId}/videos/`);
  }
}
